import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlipVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 3L4.04493 10.2L20 10.2L4 3ZM4.8073 4.16827L4.84045 9.48L16.6111 9.48L4.8073 4.16827Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 11.64H18.3111V12.36H20V11.64ZM16.3556 12.36L16.3556 11.64H12.9778L12.9778 12.36H16.3556ZM11.0222 12.36L11.0222 11.64H7.64444L7.64444 12.36H11.0222ZM5.68889 12.36V11.64H4L4 12.36H5.68889Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 21L4.04493 13.8L20 13.8L4 21Z",
			fill: "currentColor"
		})
	]
});
export default SvgFlipVertical;
